import { render, staticRenderFns } from "./widget_take_advanced_course.vue?vue&type=template&id=c66efb12&scoped=true&"
import script from "./widget_take_advanced_course.vue?vue&type=script&lang=js&"
export * from "./widget_take_advanced_course.vue?vue&type=script&lang=js&"
import style0 from "./widget_take_advanced_course.vue?vue&type=style&index=0&id=c66efb12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66efb12",
  null
  
)

export default component.exports